import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Input, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';

class RebNgxCardComponent {
    constructor() {
        /**
         * Border radius of the card
         */
        this.borderRadius = 'sm';
        /**
         * Border with of the card
         */
        this.borderWidth = 'xs';
        /**
         * Padding top and bottom of the card
         */
        this.paddingHorizontal = 'none';
        /**
         * Padding left and right of the card
         */
        this.paddingVertical = 'none';
        /**
         * Padding top and bottom of the card body
         */
        this.bodyPaddingHorizontal = '16';
        /**
         * Padding left and right of the card body
         */
        this.bodyPaddingVertical = '24';
        /**
         * Padding top and bottom of the card header
         */
        this.headerPaddingHorizontal = '16';
        /**
         * Padding left and right of the card header
         */
        this.headerPaddingVertical = '24';
        /**
         * If needed you have the option to use a container to set the card body, for example a chart
         */
        this.cardBodyContainer = null;
        /**
         * Attribute used for display the card header
         */
        this.showHeader = false;
        /**
         * Shadow of the card
         */
        this.shadow = 'none';
        /**
         * Width of the card
         */
        this.width = 'auto';
    }
    get classes() {
        return [
            `
      border-radius--${this.borderRadius}
      border--${this.borderWidth}
      padding-horizontal--${this.paddingHorizontal}
      padding-vertical--${this.paddingVertical}
      shadow--${this.shadow}
      width--${this.width}
      `
        ];
    }
    get bodyClasses() {
        return [
            `
      padding-horizontal--${this.bodyPaddingHorizontal}
      padding-vertical--${this.bodyPaddingVertical}
      `
        ];
    }
    get headerClasses() {
        return [
            `
      padding-horizontal--${this.headerPaddingHorizontal}
      padding-vertical--${this.headerPaddingVertical}
      `
        ];
    }
}
RebNgxCardComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: RebNgxCardComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
RebNgxCardComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.10", type: RebNgxCardComponent, selector: "reb-ngx-card", inputs: { borderRadius: "borderRadius", borderWidth: "borderWidth", paddingHorizontal: "paddingHorizontal", paddingVertical: "paddingVertical", bodyPaddingHorizontal: "bodyPaddingHorizontal", bodyPaddingVertical: "bodyPaddingVertical", headerPaddingHorizontal: "headerPaddingHorizontal", headerPaddingVertical: "headerPaddingVertical", cardBodyContainer: "cardBodyContainer", showHeader: "showHeader", shadow: "shadow", width: "width" }, ngImport: i0, template: "<div class=\"rn-card\" [ngClass]=\"classes\">\n  <div *ngIf=\"showHeader\" class=\"card-header\" [ngClass]=\"headerClasses\">\n    <ng-content select=\"[card-header-title]\"></ng-content>\n    <ng-content select=\"[card-header-actions]\"></ng-content>\n  </div>\n  <div class=\"card-body\" [ngClass]=\"bodyClasses\">\n    <ng-container *ngTemplateOutlet=\"cardBodyContainer\"></ng-container>\n    <ng-content select=\".card-body-content\"></ng-content>\n  </div>\n</div>\n", styles: [".rn-card{background-color:var(--palette-white-100);border-color:var(--palette-grey-95);border-style:solid}.rn-card .card-body ::ng-deep .card-body-content{display:flex;flex-direction:column}.rn-card .card-header{align-items:center;display:flex;justify-content:space-between}\n"], directives: [{ type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: RebNgxCardComponent, decorators: [{
            type: Component,
            args: [{ selector: 'reb-ngx-card', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"rn-card\" [ngClass]=\"classes\">\n  <div *ngIf=\"showHeader\" class=\"card-header\" [ngClass]=\"headerClasses\">\n    <ng-content select=\"[card-header-title]\"></ng-content>\n    <ng-content select=\"[card-header-actions]\"></ng-content>\n  </div>\n  <div class=\"card-body\" [ngClass]=\"bodyClasses\">\n    <ng-container *ngTemplateOutlet=\"cardBodyContainer\"></ng-container>\n    <ng-content select=\".card-body-content\"></ng-content>\n  </div>\n</div>\n", styles: [".rn-card{background-color:var(--palette-white-100);border-color:var(--palette-grey-95);border-style:solid}.rn-card .card-body ::ng-deep .card-body-content{display:flex;flex-direction:column}.rn-card .card-header{align-items:center;display:flex;justify-content:space-between}\n"] }]
        }], propDecorators: { borderRadius: [{
                type: Input
            }], borderWidth: [{
                type: Input
            }], paddingHorizontal: [{
                type: Input
            }], paddingVertical: [{
                type: Input
            }], bodyPaddingHorizontal: [{
                type: Input
            }], bodyPaddingVertical: [{
                type: Input
            }], headerPaddingHorizontal: [{
                type: Input
            }], headerPaddingVertical: [{
                type: Input
            }], cardBodyContainer: [{
                type: Input
            }], showHeader: [{
                type: Input
            }], shadow: [{
                type: Input
            }], width: [{
                type: Input
            }] } });

class RebNgxCardModule {
}
RebNgxCardModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: RebNgxCardModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
RebNgxCardModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: RebNgxCardModule, declarations: [RebNgxCardComponent], imports: [CommonModule], exports: [RebNgxCardComponent] });
RebNgxCardModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: RebNgxCardModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: RebNgxCardModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [RebNgxCardComponent],
                    exports: [RebNgxCardComponent],
                    imports: [CommonModule]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { RebNgxCardComponent, RebNgxCardModule };
